<template>
  <div>
    <div class="p-[10px] px-[14px] bg-white rounded-sm mb-[10px]">
      <div>
        <CruiseDetailCommenTitle class="mb-[10px]" title="了解邮轮公司" />
        <!-- <nuxt-link :to="`/company/brand?id=${cruiseData.base.company_id}&cruiseId=${cruiseId}`" target="_blank"
          v-if="cruiseData.base.logo"> -->
        <nuxt-link :to="`/company/${cruiseData.base.company_id}`" target="_blank"
          v-if="cruiseData.base.logo">
          <el-image class="w-[120px] h-[42px] mb-[10px] ml-[10px]" fit="contain" :src="cruiseData.base.logo"></el-image>
        </nuxt-link>
        <nuxt-link :to="`/company/${cruiseData.base.company_id}`" target="_blank"
          class="flex items-center ml-[10px]" v-if="cruiseData.base.company_name">
          <span class="text-[15px] text-[#62676D] font-600">{{
              cruiseData.base.company_name
          }}</span>
          <i class="icon ficon ficon-a-Vector130 ml-[10px]" />
        </nuxt-link>
        <div class="pl-[10px]" v-if="cruiseData.home_port.length">
          <el-divider />
        </div>
      </div>
      <!-- S 邮轮母港 -->
      <template v-if="cruiseData.home_port.length">
        <CruiseDetailCommenTitle class="mb-[15px]" title="邮轮母港" />
        <ul>
          <li class="flex items-center mb-[16px]" v-for="homePort in cruiseData.home_port">
            <div class="w-[23px] h-[16px] mr-[10px]" v-if="!noHomePortFlag">
              <el-image class="w-full h-full" fit="contain" :src="homePort.flag" v-if="homePort.flag"></el-image>
            </div>
            <span class="flex-1">{{ homePort.port }}</span>
          </li>
        </ul>
      </template>
      <div class="h-[20px]" v-else></div>
    </div>
    <div class="p-[10px] px-[14px] bg-white rounded-sm mb-[10px]" v-if="cruiseData.company_cruise.length">
      <CruiseDetailCommenTitle class="mb-[10px]" title="同公司邮轮" />
      <div class="mb-[-16px]">
        <nuxt-link class="block relative mb-[16px] leading-0 rounded-sm overflow-hidden" target="_blank"
          :to="`/company/cruise/${cruise.id}`" v-for="cruise in cruiseData.company_cruise" :key="cruise.id">
          <el-image class="w-full h-[163px]" fit="cover" :src="cruise.cover">
            <div slot="error" class="image-slot">
              <img src="@/assets/img/company/brand-placeholder1.png" />
              <span>加载失败</span>
            </div>
            <div slot="placeholder" class="image-slot">
              <img src="@/assets/img/company/brand-placeholder1.png" />
              <span>加载中</span>
            </div>
          </el-image>
          <div
            class="absolute w-full left-0 bottom-0 h-[56px] cruise__name px-[18px] flex items-center text-white text-[15px] font-500">
            {{ cruise.name }}
          </div>
        </nuxt-link>
      </div>
    </div>
    <!-- <div class="p-[10px] px-[14px] bg-white rounded-sm mb-[10px]" v-if="cruiseData.class_cruise.length && !onlyHasBase">
      <CruiseDetailCommenTitle class="mb-[10px]" title="同船舶类型" />
      <div class="mb-[-16px]">

        <nuxt-link class="block relative mb-[16px] leading-0 rounded-sm overflow-hidden" target="_blank"
          :to="`/company/cruise/${cruise.id}`" v-for="cruise in cruiseData.class_cruise" :key="cruise.id">
          <el-image class="w-full h-[163px]" fit="cover" :src="cruise.cover">
            <div slot="error" class="image-slot">
              <img src="@/assets/img/company/brand-placeholder1.png" />
              <span>加载失败</span>
            </div>
            <div slot="placeholder" class="image-slot">
              <img src="@/assets/img/company/brand-placeholder1.png" />
              <span>加载中</span>
            </div>
          </el-image>
          <div
            class="absolute w-full left-0 bottom-0 h-[56px] cruise__name px-[18px] flex items-center text-white text-[15px] font-500">
            {{ cruise.name }}
          </div>
        </nuxt-link>
      </div>
    </div> -->
  </div>
</template>

<script>
import CruiseDetailCommenTitle from "@/views/company/CruiseDetailCommenTitle.vue";

export default {
  name: "CruiseDetailSlideRight",
  components: {
    CruiseDetailCommenTitle,
  },
  props: {
    cruiseData: {
      type: Object,
      default: () => ({
        left_navigation: [],
        base: {
          name: "",
          describe: "", //简述
          introduction: "", //介绍
          label: [], // 标签
          //视频&图片
          images: [],
          attributes: {},
        },
        cabins: [],
        restaurants: [],
        plays: [],
        decks: [],
        photos: [],
        // 当前航次
        voyage: {
          product_tours: [],
        },
        all_voyage: [],
        rank: {},
        news: [],
      }),
    },
    onlyHasBase: { // 只有基本信息不展示  同公司船舶 ps: 王冬
      type: Boolean,
      default: false
    }
  },
  computed: {
    cruiseId() {
      return this.$route.params.cruiseId;
    },
    noHomePortFlag() {
      return !this.cruiseData.home_port.some(({ flag }) => !!flag)
    }
  }
};
</script>
<style lang="scss" scoped>
.cruise__name {
  transition: .2s color ease;
  background: linear-gradient(360deg,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(217, 217, 217, 0) 143.33%);
}
.cruise__name:hover {
  --tw-text-opacity: 1;
  color: rgba(242, 91, 59, var(--tw-text-opacity));
}
.image-slot {
  background: url("@/assets/img/company/brand-placeholder.png") no-repeat center center;
  background-size: 100% 100%;
  font-size: 13px;
  font-weight: 500;
  height: 163px;
  padding-top: 20px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
}
.image-slot img {
  margin: auto;
}
.image-slot span {
  display: inline-block;
  margin-top: 14px;
  text-align: center;
}
</style>
